import React from 'react';
import styles from './Checkbox.module.css';

export default function Checkbox({ label, id, checked, onChange }) {
  return (
    <div className={styles.container}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className={styles.input}
      />
      <label htmlFor={id} className={styles.label}>{label}</label>
    </div>
  );
} 